export const appFontStyle = {
  fontFamily: 'Roboto,sans-serif',
  fontSize: '1rem',
  color: '#000'
}
